import { render } from "./Blank.vue?vue&type=template&id=94b6e4ec&scoped=true&ts=true"
import script from "./Blank.vue?vue&type=script&setup=true&lang=ts"
export * from "./Blank.vue?vue&type=script&setup=true&lang=ts"

import "./Blank.vue?vue&type=style&index=0&id=94b6e4ec&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b6e4ec"],['__file',"src/views/Blank.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94b6e4ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94b6e4ec', __exports__)) {
    console.log('reload')
    api.reload('94b6e4ec', __exports__)
  }
  
  module.hot.accept("./Blank.vue?vue&type=template&id=94b6e4ec&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('94b6e4ec', render)
  })

}


export default __exports__